import React, { useContext } from 'react';
import { ThemeContext } from '../../ContextProvider/ThemeContext';
import styles from './Experiences.module.css';

const Experiences = () => {
	const { newTheme } = useContext(ThemeContext);
	return (
		<div className={styles.experiences}>
			<h1
				style={{ color: `${newTheme.title}` }}
				className={styles.heading}
			>
				Experience
			</h1>
			<div className={styles.borderBottom} />

			<div className={styles.container}>
				<div className={styles.position}>
					Software Engineer | {' '}
					<a href='https://www.turnoutnow.com/' target="_blank" rel="noreferrer">TurnoutNow</a>
				</div>
				<div className={styles.date}>August 2022 - Present</div>
				<fieldset className={styles.responsibilites}>
					<legend>
						<h3> Roles & responsibilites </h3>
					</legend>
					<ul>
						<li>
							Implemented cloud infrastructure using AWS
							services such as Lambda, DynamoDB, S3, Step
							Functions etc.
						</li>
						<li>
							Develop and Maintain serverless applications using
							AWS Lambda, AWS AppSync, API Gateway etc.
						</li>
						<li>
							Collaborated with architects, developers, and
							operations teams to gather requirements and
							translate them into scalable and secure solutions.
						</li>

					</ul>
				</fieldset>
			</div>
			<br />

			{/*  Masai experience  */}

			<div className={styles.container}>
				<div className={styles.position}>
					Instructional Associate | Full Stack Developer{' '}
					<a href='https://www.masaischool.com/' target="_blank" rel="noreferrer">Masai School</a>
				</div>
				<div className={styles.date}>November 2021 - August 2022</div>
				<fieldset className={styles.responsibilites}>
					<legend>
						<h3> Roles & responsibilites </h3>
					</legend>
					<ul>
						<li>
							Develop web pages using HTML,CSS, JavaScript,
							React. Ensured responsive and visually appealing
							designs.
						</li>
						<li>
							Solved technical queries of students related to
							coding/DSA and help them with their assignments.
							Also conducted lectures whenever needed.
						</li>
						<li>
							Led the team of IAs as star IA to guide and train
							them about their role and responsibilities.
						</li>

					</ul>
				</fieldset>
			</div>
			<br />
			{/*  AIDA experience  */}

			<div className={styles.container}>
				<div className={styles.position}>
					Analyst | {' '}
					<a href='https://www.linkedin.com/company/aidaconsultants/?originalSubdomain=in' target="_blank" rel="noreferrer">@ AIDA Management</a>
				</div>
				<div className={styles.date}>December 2019 - April 2021</div>
				<fieldset className={styles.responsibilites}>
					<legend>
						<h3> Roles & responsibilites </h3>
					</legend>
					<ul>
						<li>
							Collaborated with cross-functional teams to gather
							and analyze user requirements, propose solutions,
							and ensure the successful delivery of projects.
						</li>
						<li>
							Created and maintained technical documentation
							to facilitate future development and support
							activities.
						</li>
					</ul>
				</fieldset>
			</div>

			<br />
			{/*  NBCC experience  */}

			<div className={styles.container}>
				<div className={styles.position}>
					Graduate Apprentice | Civil Engineering{' '}
					<a href='https://www.linkedin.com/company/nbcc-india-limited/' target="_blank" rel="noreferrer">@ NBCC (India) Limited</a>
				</div>
				<div className={styles.date}>December 2018 - December 2019</div>
				<fieldset className={styles.responsibilites}>
					<legend>
						<h3> Roles & responsibilites </h3>
					</legend>
					<ul>
						<li>
							Supported project planning by collecting and documenting
							measurements.
						</li>
						<li>
							Worked alongside senior team members to learn all related job
							tasks and roles.
						</li>
						<li>
							Worked on Reading and Analyzing of structural and
							Architectural drawings
						</li>
						<li>
							Checked Client Correspondence, Hindrance Register, Extension of Time, etc.
						</li>
					</ul>
				</fieldset>
			</div>

		</div>
	);
};

export default Experiences;
